// /blockUsers DataGrid 컬럼 정의.
// flex 전면 제거 → width + minWidth 고정.

import React from "react";
import { Link } from "react-router-dom";
import type { GridColDef, GridRenderCellParams } from "@mui/x-data-grid";
import { OverflowTooltip } from "components/list";
import { IBlockUser } from "../interfaces";

const linkStyle: React.CSSProperties = {
  textDecoration: "underline",
  fontWeight: 600,
  color: "var(--color-primary)",
};

// updatedDate 문자열을 "YYYY년 M월 D일 오전/오후 h:mm:ss" 형태로 포맷 (기존 로직 유지)
const formatBlockDate = (value: unknown): string => {
  const date = new Date(value as string);
  const hours = date.getHours();
  const minutes = date.getMinutes();
  const seconds = date.getSeconds();

  const formattedHours = hours % 12 === 0 ? 12 : hours % 12;
  const amPm = hours < 12 ? "오전" : "오후";
  const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;
  const formattedSeconds = seconds < 10 ? `0${seconds}` : seconds;

  return `${date.getFullYear()}년 ${date.getMonth() + 1}월 ${date.getDate()}일 ${amPm} ${formattedHours}:${formattedMinutes}:${formattedSeconds}`;
};

export const blockUserColumns: GridColDef<IBlockUser>[] = [
  {
    field: "id",
    headerName: "ID",
    type: "number",
    width: 84,
    minWidth: 72,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "blockingUserId",
    headerName: "차단한 사용자 ID",
    type: "string",
    width: 132,
    minWidth: 110,
    renderCell: (params: GridRenderCellParams) => (
      <OverflowTooltip value={params.value}>
        <Link to={`/users/${params.value}`} style={linkStyle}>
          {params.value}
        </Link>
      </OverflowTooltip>
    ),
  },
  {
    field: "blockedUserId",
    headerName: "차단된 사용자 ID",
    type: "string",
    width: 132,
    minWidth: 110,
    renderCell: (params: GridRenderCellParams) => (
      <OverflowTooltip value={params.value}>
        <Link to={`/users/${params.value}`} style={linkStyle}>
          {params.value}
        </Link>
      </OverflowTooltip>
    ),
  },
  {
    field: "updatedDate",
    headerName: "수정일",
    type: "string",
    width: 220,
    minWidth: 170,
    renderCell: (params: GridRenderCellParams) => (
      <OverflowTooltip value={formatBlockDate(params.value)} />
    ),
  },
];
